// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSortAzReverse24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_17219_140708)">
					<path d="M21.6456 10.9997L21.5613 11.071C21.2631 11.2915 20.8351 11.2656 20.5627 10.9997L18.8054 9.24241V18.6255C18.8054 19.0469 18.4618 19.3906 18.0403 19.3906C17.6188 19.3906 17.2751 19.0469 17.2751 18.6255V9.24889L15.5178 11.0062C15.2195 11.3045 14.7332 11.3045 14.4349 11.0062C14.1366 10.7079 14.1366 10.2216 14.4349 9.92328L17.4956 6.8626C17.7939 6.56432 18.2802 6.56432 18.5785 6.8626L21.6392 9.92328C21.9374 10.2216 21.9374 10.7079 21.6392 11.0062L21.6456 10.9997Z" />
					<path d="M7.06855 5.40039L5 11.217H6.54979L6.95831 9.97195H9.07874L9.49375 11.217H11.0306L8.9685 5.40039H7.06855ZM7.30199 8.92795L7.98935 6.83995H8.04122L8.72858 8.92795H7.29551H7.30199Z" />
					<path d="M5.2854 13.8366H8.50819L5.2854 18.0775V18.9269H10.4665V17.7208H7.25668L10.4665 13.48V12.624H5.2854V13.8366Z" />
				</g>
				<defs>
					<clipPath id="clip0_17219_140708">
						<rect width={16.8726} height={14} transform="translate(5 5.40039)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgSortAzReverse24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSortAzReverse24;
